export default {"src":"/_next/static/media/chevronRight.3b7b85ca.svg","height":9,"width":6};